var React = require('react');

function BlogPostsBgTriangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M159.93 29.2891L18.9765 14.442M159.93 29.2891L85.6315 63.0047M159.93 29.2891L55.4558 114.337M18.9765 14.442L85.6315 63.0047M18.9765 14.442L55.4558 114.337M85.6315 63.0047L55.4558 114.337","stroke":"#DADADA"}));
}

BlogPostsBgTriangle.defaultProps = {"width":"162","height":"133","viewBox":"0 0 162 133","fill":"none"};

module.exports = BlogPostsBgTriangle;

BlogPostsBgTriangle.default = BlogPostsBgTriangle;
